import { render, staticRenderFns } from "./GeneralLedgerIndex.vue?vue&type=template&id=7c096e8b&scoped=true"
import script from "./GeneralLedgerIndex.vue?vue&type=script&lang=js"
export * from "./GeneralLedgerIndex.vue?vue&type=script&lang=js"
import style0 from "./GeneralLedgerIndex.vue?vue&type=style&index=0&id=7c096e8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c096e8b",
  null
  
)

export default component.exports